<div class="tools-buttons-container">
  <div class="individual-tools" id="individualToolsBar">
    <loading [isLoading]="isLoadingButton"></loading>
    <!-- para el panel de locations global -->
      <div *ngIf="isGlobal && !isBranding" class="tool-option" (click)="this.openFilter()" matTooltip="Filtrar" id="panelLocationFilterButton">
        <mat-icon *ngIf="ApplyFilter">filter_alt_off</mat-icon>
        <img src="/assets/img/icon_filter.png" *ngIf="!ApplyFilter">
      </div>
      <div *ngIf="isGlobal && isBranding" class="tool-option" (click)="this.openAvailabilityFilter()" matTooltip="Filtrar">
        <mat-icon *ngIf="ApplyAvailabilityFilter">event_busy</mat-icon>
        <mat-icon *ngIf="!ApplyAvailabilityFilter">event_note</mat-icon>
      </div>
      <div *ngIf="isGlobal && btnDownExcel" class="tool-option" (click)="this.getExcel()" matTooltip="Descargar lista en formato Excel" id="panelLocationExcelButton">
        <img src="/assets/img/icon_download_xls.png" width="25px">
      </div>
      <div *ngIf="isGlobal && 'ServiceAssignmentAnimation' | permissionFilter " class="tool-option" (click)="this.startAssignment()" matTooltip="Ver asignación de unidades">
        <mat-icon>find_replace</mat-icon>
      </div>

      <!-- para el panel de detalles de location -->
      <div *ngIf="hasValetParking && isDetailLocations && 'ValetParking' | permissionFilter" class="tool-option" [ngClass]="{'yellow-border': isValetParking}" (click)="ValetParking()" matTooltip="Valet Parking">
        <mat-icon *ngIf="!isValetParking">local_parking</mat-icon>
        <img *ngIf="isValetParking" src="../../../../assets/img/no_parking.png">
      </div>
      <div *ngIf="isDetailLocations && 'LocationRoute' | permissionFilter" class="tool-option" (click)="getLocationRoute()" matTooltip="Trazabilidad de ruta">
        <img src="/assets/img/icon_history.png" width="25px">
      </div>
      <div *ngIf="blockingObject.isVisibleBlocking && 'BloquearRuptela-L' | permissionFilter">
        <div class="tool-option" (click)="OpenBlokingDialog()" matTooltip="Bloqueo de auto">
          <mat-icon >{{ blockingObject.blockingIcon }}</mat-icon>
        </div>
      </div>
      <div *ngIf="isDetailLocations && !isMonitor">
        <div class="tool-option" [ngClass]="{'disabled': isLoadingImages , 'display-none': !isLoadingImages && images?.length < 1 }" (click)="images && images?.length > 0 ? openCarouselPopup() : null" matTooltip="Imagenes">
          <mat-icon > crop_original </mat-icon>
        </div>
      </div>
      <div *ngIf="isDetailLocations && isReloadable">
        <div class="tool-option" (click)="refreshDetails()" matTooltip="Sincronizar" [disabled]="isLoadingParent">
          <img src="/assets/img/icon_sync.png" width="25px">
        </div>
      </div>
      <div *ngIf="isDetailLocations && CordX != undefined && CordX != '' && CordY != undefined && CordY != ''">
        <div class="tool-option" (click)="openStreetView()" matTooltip="StreetView">
          <img src="/assets/img/doll-icon.png" width="25px">
        </div>
      </div>
      <!-- <div *ngIf="isDetailLocations && identifier != null && identifier != ''">
        <div class="tool-option" [ngClass]="{'yellow-border': geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible}" (click)="openRecurrentPlaces()" matTooltip="Lugares concurridos">
          <img src="/assets/img/icon_history.png" width="25px">
        </div>
      </div> -->
      
      

      <!-- para el panel de Geocercas -->
      <div class="tool-option" *ngIf="isGeofencePanel && 'AgregarGeocerca' | permissionFilter" (click)="onClickEditGeofence()"  matTooltip="Crear">
        <img src="assets/img/icon_plus.png" style="width: 25px;">
      </div>
      <div class="tool-option" *ngIf="isGeofenceDetails && 'EditarGeocerca' | permissionFilter" (click)="onClickEditGeofence()" matTooltip="Editar">
        <mat-icon>edit</mat-icon>
      </div>
      <div class="tool-option" *ngIf="isGeofenceDetails && 'DuplicarGeocerca' | permissionFilter" (click)="onClickDuplicateGeofence()" matTooltip="Duplicar">
        <mat-icon>control_point_duplicate</mat-icon>
      </div>
      <div class="tool-option" *ngIf="isGeofenceDetails && 'BorrarGeocerca' | permissionFilter" (click)="onClickDeleteGeofence()" matTooltip="Borrar">
        <mat-icon>delete</mat-icon>
      </div>
  </div>
</div>
